import { FlexColumn, FullContainer } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { useStyles } from '../../../../hooks/useStyles';
import { fleetDriverReloadState } from '../../../../storage/fleetDrivers';
import { FleetDriverDetail } from '../../../../types/drivers';
import FleetDriverData from './FleetDriverData';
import FleetDriverForm from './FleetDriverForm';

type Props = Readonly<{ driver: FleetDriverDetail }>;

function FleetDriverDetails({ driver }: Props) {
  const { css, theme } = useStyles();
  const [editDriver, setEditDriver] = useState(false);
  const setReload = useSetRecoilState(fleetDriverReloadState);

  const closeEdit = () => {
    setEditDriver(false);
  };

  return (
    <FullContainer verticalFlex>
      <FlexColumn
        classNames={css({
          flex: 1,
          overflow: 'auto',
          [theme.mediaQuery.large]: {
            maxWidth: '50%',
          },
          [theme.mediaQuery.extraLarge]: {
            maxWidth: '40%',
          },
        })}
        gap={theme.sizing.scale300}
      >
        {editDriver ? (
          <FleetDriverForm
            afterSave={() => {
              setReload((prev) => prev + 1);
              closeEdit();
            }}
            driver={driver}
            onCancel={closeEdit}
          />
        ) : (
          <FleetDriverData
            driver={driver}
            editDriver={setEditDriver}
          />
        )}
      </FlexColumn>
    </FullContainer>
  );
}

export default FleetDriverDetails;
